import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Space, Tooltip, Checkbox, Input, Switch } from 'antd';
import { FilterFilled, ProductFilled, WarningFilled } from '@ant-design/icons';
import "./ControlsFilter.css"

const ControlsFilter = ({
  searchTerm,
  filters,
  onSearchChange,
  onFiltersChange,
  onSelectAllChange,
  notShowFields,
  priorities,
  types
}) => {
  const [loading, setLoading] = useState({
    priorities: false,
    types: false
  });

  // Menú de prioridades dinámico
  const priorityMenu = {
    items: [
      { key: 'all', label: 'Todas las prioridades' },
      ...priorities.map(priority => ({
        key: priority.name,
        label: priority.name
      }))
    ],
    onClick: (e) => onFiltersChange({
      ...filters,
      priority: e.key === 'all' ? null : e.key
    })
  };

  // Menú de tipos dinámico
  const typeMenu = {
    items: [
      { key: 'all', label: 'Todos los tipos' },
      ...types.map(type => ({
        key: type.name,
        label: type.name
      }))
    ],
    onClick: (e) => onFiltersChange({
      ...filters,
      type: e.key === 'all' ? null : e.key
    })
  };

  // Menú de estados
  const enabledMenu = {
    items: [
      { key: 'all', label: 'Todos' },
      { key: 'enabled', label: 'Asignados' },
      { key: 'disabled', label: 'Desasignados' }
    ],
    onClick: (e) => onFiltersChange({
      ...filters,
      enabled: e.key === 'all' ? null : e.key === 'enabled'
    })
  };

  const handleClearFilters = () => {
    onFiltersChange({
      priority: null,
      type: null,
      enabled: null, 
      selectAllDisabled: false,
      selectAllChecked: false
    });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, width: '100%' }}>
      {/* Filtros a la izquierda */}
      <Space>
        {!notShowFields && (
          <Dropdown menu={enabledMenu} trigger={['click']}>
            <Button
              className={`control-filter ${filters.enabled !== null ? 'control-filter--active' : ''}`}
              size="small"
              icon={<FilterFilled />}
              type="default"
            >
              Estado
            </Button>
          </Dropdown>
        )}
  
        <Dropdown menu={priorityMenu} trigger={['click']} disabled={loading.priorities}>
          <Button
            className={`control-filter ${filters.priority !== null ? 'control-filter--active' : ''}`}
            size="small"
            icon={<WarningFilled />}
            type="default"
            loading={loading.priorities}
          >
            Prioridad
          </Button>
        </Dropdown>
  
        <Dropdown menu={typeMenu} trigger={['click']} disabled={loading.types}>
          <Button
            className={`control-filter ${filters.type !== null ? 'control-filter--active' : ''}`}
            size="small"
            icon={<ProductFilled />}
            type="default"
            loading={loading.types}
          >
            Tipo
          </Button>
        </Dropdown>
  
        {(filters.priority || filters.type || filters.enabled !== null) && (
          <Button
            className="control-filter"
            size="small"
            onClick={() => {
              handleClearFilters();
              onFiltersChange({
                priority: null,
                type: null,
                enabled: null,
                selectAllDisabled: false,
                selectAllChecked: false
              });
            }}
          >
            X
          </Button>
        )}
      </Space>
  
      {/* Contenedor para buscador y checkbox */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ position: 'relative' }}>
          <Input.Search
            className="search-table"
            placeholder="Buscar Controles"
            allowClear
            onChange={onSearchChange}
            value={searchTerm}
          />
        </div>
        
        {!notShowFields && (
          <div style={{ marginLeft: 47, marginRight: 16 }}>
            <Tooltip 
              title={filters.selectAllChecked ? "Todos están asignados" : "Asignar todos"}
              placement="top"
            >
              <Switch
                checked={filters.selectAllChecked || false}
                onChange={onSelectAllChange}
                disabled={filters.selectAllDisabled}
                checkedChildren="✓"
                /* unCheckedChildren="✕" */
                style={{
                  backgroundColor: filters.selectAllChecked ? '#52c41a' : undefined
                }}
              />
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default ControlsFilter;